import { render, staticRenderFns } from "./CPAppropriatenessTest.vue?vue&type=template&id=0682512e&scoped=true&"
import script from "./CPAppropriatenessTest.vue?vue&type=script&lang=ts&"
export * from "./CPAppropriatenessTest.vue?vue&type=script&lang=ts&"
import style0 from "./CPAppropriatenessTest.vue?vue&type=style&index=0&id=0682512e&prod&lang=scss&"
import style1 from "./CPAppropriatenessTest.vue?vue&type=style&index=1&id=0682512e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0682512e",
  null
  
)

export default component.exports